var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceiptTax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.65131 8.79087L9.41881 5.02337M5.96529 5.33733H5.97157M9.10487 8.47691H9.11115M11.9305 13.1863V3.13962C11.9305 2.44604 11.3682 1.88379 10.6746 1.88379H4.39548C3.7019 1.88379 3.13965 2.44604 3.13965 3.13962V13.1863L5.33736 11.9305L7.53506 13.1863L9.73277 11.9305L11.9305 13.1863ZM6.27923 5.33733C6.27923 5.51072 6.13867 5.65129 5.96527 5.65129C5.79188 5.65129 5.65131 5.51072 5.65131 5.33733C5.65131 5.16394 5.79188 5.02337 5.96527 5.02337C6.13867 5.02337 6.27923 5.16394 6.27923 5.33733ZM9.41881 8.47691C9.41881 8.65031 9.27825 8.79087 9.10486 8.79087C8.93146 8.79087 8.7909 8.65031 8.7909 8.47691C8.7909 8.30352 8.93146 8.16296 9.10486 8.16296C9.27825 8.16296 9.41881 8.30352 9.41881 8.47691Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptTax);
export default __webpack_public_path__ + "static/media/receipt-tax.5903d835ff2b385b4e72d6ae711418b2.svg";
export { ForwardRef as ReactComponent };